export default { sha: '960cb567238f802b7b7aee9b2e10a3f949632037', buildNumber: 'undefined' }
